import { useQuery } from "@tanstack/react-query";

import { axiosInstance } from "../axios/axiosInstance";

export const key = ["archiveKey"];
export const useGetConversations = (category) =>
  useQuery(
    [...key, category],
    async () => {
      const { data } = await axiosInstance.get(
        `admin/messages/conversations?category=${category}&per_page=15`
      );
      return data.data;
    },
    {
      enabled: !!category,
      staleTime: Infinity,
    }
  );
